import { IcoCheck } from '../../../../component/icon/check-icon';

interface ILegendProps {
  text: string;
  bgColor: string;
  displayIcon?: boolean;
  border?: boolean;
}

export const Legend = ({
  text,
  bgColor,
  displayIcon = true,
  border = false,
}: ILegendProps): JSX.Element => {
  return (
    <div className="layers-legends-legend-container">
      <div
        className="layers-legends-legend-icon-container"
        style={{
          backgroundColor: bgColor,
          border: border ? '1px solid #888888' : 'none',
        }}
      >
        {displayIcon && (
          <IcoCheck
            cy="LayersLegends"
            circleColor="transparent"
            height="12"
            width="12"
          />
        )}
      </div>
      <p>{text}</p>
    </div>
  );
};
